export default __webpack_public_path__ + "static/banner_iot-a77bf4664d35abab6d62682e70c930c6.webp";